import axios from "axios";
import Cookies from "js-cookie";
import { Message } from 'element-ui'
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 2000000,
});
http.interceptors.request.use(
  (config) => {
    if (Cookies.get("token")) {
      config.headers["authorization"] = `Bearer ${Cookies.get("token")}`;
    }
    return config;
  },
  (error) => {
    // 发生错误做的一些事情
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if(error.response.status !== 404){
      Message.error(error.response.data.detail)
    }
    return Promise.reject(error);
  }
);
export { http };
